import React from "react";

function ImageBox({ image, title }) {
  return (
    <div className="imageBox">
      <img src={image} alt={title} />
    </div>
  );
}

export default ImageBox;
